// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Tp-z","selected":"Up-z"};